import React from 'react'

import CreateSite from '../../../components/CreateSite'
import ContextMenu from '../../../components/ContextMenu'

export default function () {
  return (
    <div className='container'>
      <ContextMenu renderTitle={() => <h1 className='title'>Create a new site</h1>}></ContextMenu>
      <CreateSite />
    </div>
  )
}
